import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import {
  Stepper,
  Step,
  StepButton,
  StepContent,
  Button,
  Paper,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  // Checkbox,
  Hidden,
  StepLabel,
} from '@material-ui/core'
import { DATA_API_URL } from 'utils/AllURLs'
import { create, update } from 'actions/data'
import Tooltip from 'components/theme/HelpTooltip'
import {
  updateFormField,
  updateEntity,
  updateMessageSamples,
  updateA2p10dlc,
} from './redux'
import CampaignStep from './CampaignStep'
import { capitalize } from 'lodash'
import NumberFormat from 'react-number-format'
import { toggleDialog } from 'actions/view'
// import TypewriterMarkdown from 'components/theme/TypewriterMarkdown'

// Custom Number Format Input for EIN or CBN
function BusinessNumber(props) {
  const { inputRef, onChange, mask, format, ...other } = props

  // Handler to bridge react-number-format's value with Material-UI's TextField
  const handleChange = values => {
    onChange({
      target: {
        value: values.value,
        name: props.name,
      },
    })
  }

  return (
    <NumberFormat
      {...other}
      getInputElement={ref => inputRef(ref)}
      onValueChange={handleChange}
      format={format}
      mask={mask}
    />
  )
}

function PhoneNumber(props) {
  const { inputRef, onChange, ...other } = props

  // Handler to bridge react-number-format's value with Material-UI's TextField
  const handleChange = values => {
    onChange({
      target: {
        value: values.value,
        name: props.name,
      },
    })
  }

  return (
    <NumberFormat
      {...other}
      getInputElement={ref => inputRef(ref)}
      onValueChange={handleChange}
      format="+1 (###) ###-####"
      allowEmptyFormatting
      mask="_"
    />
  )
}

const styles = theme => ({
  root: {
    width: '90%',
  },
  button: {
    marginTop: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
  actionsContainer: {
    marginBottom: theme.spacing.unit * 2,
  },
  resetContainer: {
    padding: theme.spacing.unit * 3,
  },
  titleText: {
    marginBottom: 14,
    fontSize: 25,
    fontWeight: 'bold',
    color: '#014c94',
    [theme.breakpoints.down('sm')]: {
      fontSize: 19,
      // marginBottom: 12,
    },
    overflow: 'hidden',
  },
  formControlLabelRoot: {
    marginTop: 15,
  },
  errorText: {
    // color: theme.palette.orange,
    marginBottom: 16,
    marginLeft: 20,
    border: `1px solid ${theme.palette.red}`,
    borderRadius: 10,
    padding: 10,
    backgroundColor: '#ffd9d7',
  },
  errorStep: {
    color: theme.palette.orange,
  },
})

const A2P10DLC = ({
  classes,
  updateFormField,
  updateEntity,
  updateMessageSamples,
  formData,
  campaigns,
  useCaseDrafts,
  createPhonePayload,
  create,
  update,
  updateA2p10dlc,
  toggleDialog,
  a2p10dlc,
  sms_double_opt_disclaimer,
  idTokenPayload,
  brandregistrationerrors,
  handleClose,
  directive,
  useCase,
  ...props
}) => {
  const [activeStep, setActiveStep] = useState(0)
  const [stepsWithErrors, setStepsWithErrors] = useState([])
  const [fieldsChanged, setFieldsChanged] = useState(false)
  // const [editingUseCase, setEditingUseCase] = useState(null)

  // const handleEditUseCase = useCase => {
  //   setEditingUseCase(useCase)
  // }

  // const handleBackToList = () => {
  //   setEditingUseCase(null) // Return to the list view
  // }

  // const availableUseCases = [
  //   { entityType: 'useCaseDraft', entityKey: 'MARKETING' },
  //   { entityType: 'campaign', entityKey: 'CUSTOMER_CARE' },
  // ]

  // console.log('brandregistrationerrors: ', brandregistrationerrors)

  // Function to parse and format error messages
  const getFormattedErrorMessage = () => {
    if (!brandregistrationerrors) return null

    // wait it seems like this solution is just getting it from brandregistrationerrors...
    const errorMessages = Object.values(brandregistrationerrors || {})?.flatMap?.(
      errors =>
        errors?.map?.(error => {
          if (error?.customerProfileError) {
            // Handle customer profile errors - only include solutions if they exist
            return error?.customerProfileError?.solutions
              ? `${error.customerProfileError.description}\n\nPossible solutions: ${error.customerProfileError.solutions}`
              : error.customerProfileError.description
          } else {
            // Handle brand registration errors
            const errorDetails = Object.values(error)[0]
            return `${errorDetails.description}\n\nPossible solutions: ${errorDetails.solutions}`
          }
        }),
    )

    // if (window.marked?.parse) {
    // return (
    //   <div
    //     dangerouslySetInnerHTML={{
    //       __html: window.marked?.parse(errorMessages.join('\n\n')),
    //     }}
    //     className={classes.errorText}
    //   />
    // )
    // }

    // return <div className={classes.errorText}>{errorMessages.join('\n\n')}</div>

    // return (
    //   <div className={classes.errorText}>
    //     <TypeAnimation content={errorMessages.join('\n\n')} />
    //   </div>
    // )

    return (
      <div className={classes.errorText}>
        {errorMessages.map(message => (
          <div style={{ marginBottom: 10 }}>{message}</div>
        ))}
      </div>
    )
  }

  const stepFields = {
    0: ['iso_country', 'business_type', 'volumeNeeds'],
    1: [
      'company_type',
      'business_name',
      'website_url',
      'business_industry',
      'business_registration_number',
    ],
    2: ['street', 'street_secondary', 'city', 'region', 'postal_code'],
    3: [
      'first_name',
      'last_name',
      'job_position',
      'business_title',
      'phone_number',
      'email',
    ],
    4: [], // Add fields for the messaging information step if any
  }

  const errorFields = Object.values(brandregistrationerrors || {})?.flatMap?.(
    brandErrors => brandErrors?.flatMap?.(error => error?.registrationerrorfields),
  )

  // Function to check if a step contains fields with errors
  const stepContainsErrorFields = stepIndex => {
    if (!brandregistrationerrors) return false

    return stepFields[stepIndex].some(field => errorFields.includes(field))
  }

  // Update stepsWithErrors when brandregistrationerrors change
  useEffect(() => {
    if (brandregistrationerrors) {
      const newStepsWithErrors = steps.reduce((acc, _, index) => {
        if (stepContainsErrorFields(index)) {
          acc.push(index)
        }
        return acc
      }, [])
      setStepsWithErrors(newStepsWithErrors)
      setActiveStep(Math.min(...newStepsWithErrors))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [brandregistrationerrors])

  // Helper function to check if there's an actual application
  const hasExistingApplication = () => {
    return Boolean(Object.keys(a2p10dlc || {}).length)
  }

  const disabled = hasExistingApplication() && !brandregistrationerrors

  const steps = [
    'Prerequisites',
    'Business Information',
    'Business Address',
    'Authorized Representative',
    'Messaging Information',
    // formData?.business_type === 'Sole Proprietorship' ||
    // formData?.volumeNeeds === 'lowVolume'
    //   ? 'Use case'
    //   : 'Use cases',
  ]

  const handleChange = event => {
    updateFormField(event.target.name, event.target.value)
    setFieldsChanged(true)
  }

  const handleNext = () => {
    setActiveStep(prevActiveStep => prevActiveStep + 1)
  }

  const handleBack = () => {
    setActiveStep(prevActiveStep => prevActiveStep - 1)
  }

  const handleFinish = () => {
    console.log('Form Data on Finish:', formData)
    const campaignType =
      // TODO: change this to be a specific campaign type
      formData.volumeNeeds === 'highVolume' ? 'MIXED' : 'LOW_VOLUME'

    const entity = {
      // change this to be on the initialRequest object
      ...formData,
      phone_number: `+1${formData.phone_number}`,
      campaigns,
      useCaseDrafts: {
        ...useCaseDrafts,
        [campaignType]: {
          ...(useCaseDrafts?.[campaignType] || {}),
          messageFlow:
            useCaseDrafts?.[campaignType]?.messageFlow +
            '\n\n' +
            'Leads will then receive the following messages for double opt-in: ' +
            `"${sms_double_opt_disclaimer}"` +
            '\n' +
            '"Reply CONFIRM to receive messages from us.  We respect your privacy and you can reply STOP to opt-out at any time. We will occasionally send you news and updates for our events and products. Message and data rates apply."',
          phoneSIDs: { [createPhonePayload?.phone_number_sid]: true },
        },
      },
      /* This adds the phone number stored in cognito to the a2p10dlc entity.
      That way, we can get it in the reach_twilio_10dlc_status lambda by fetching the entity,
      instead of having to use Cognito to look it up. */
      /* cognito_ */ user_phone_number: idTokenPayload?.phone_number,
      /* cognito_ */ user_email: idTokenPayload?.email,
    }

    console.log('entity:', entity)

    create({
      entityType: 'a2p10dlc',
      entity,
      url: `${DATA_API_URL}/a2p10dlc`,
      hasSchema: false,
      snackbarMessage: 'Successfully submitted compliance information!',
    }).then(async () => {
      const urlencoded = new URLSearchParams()
      // urlencoded.append('account_id', idTokenPayload?.account_id)
      // urlencoded.append('username', idTokenPayload?.username)
      urlencoded.append('phone', idTokenPayload?.phone_number)
      urlencoded.append('email', idTokenPayload?.email)

      const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: urlencoded,
        redirect: 'follow',
      }

      try {
        const response = await fetch(
          'https://leads.vastreach.com/customform/cipost/330ad4e9-6363-4ba9-b90a-69fdb977c011',
          requestOptions,
        )
        const result = await response.text()
        console.log(result)
      } catch (error) {
        console.log('error', error)
      }

      toggleDialog({ dialog: 'A2P10DLC', open: false })
    })
  }

  const handleResubmit = () => {
    if (!hasExistingApplication()) return

    const existingApplicationData = Object.values(a2p10dlc)[0]
    console.log('existingApplicationData: ', existingApplicationData)

    const entity = {
      ...existingApplicationData,
      ...formData,
      phone_number: existingApplicationData.phone_number,
    }
    console.log('entity: ', entity)

    updateA2p10dlc({ entity }).then(() => handleClose())
  }

  function getStepContent() {
    switch (activeStep) {
      case 0:
        return (
          <>
            <FormControl fullWidth margin="normal">
              <InputLabel>Country</InputLabel>
              <Select
                disabled={disabled && !stepContainsErrorFields(activeStep)}
                value={formData.iso_country || ''}
                onChange={handleChange}
                name="iso_country"
              >
                {[
                  { value: 'US', label: 'United States' },
                  { value: 'CA', label: 'Canada' },
                ].map(country => (
                  <MenuItem key={country.value} value={country.value}>
                    {country.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl fullWidth margin="normal">
              <InputLabel>Business Type</InputLabel>
              <Select
                disabled={disabled && !stepContainsErrorFields(activeStep)}
                value={formData.business_type || ''}
                onChange={handleChange}
                name="business_type"
              >
                {[
                  'Sole Proprietorship',
                  'Partnership',
                  'Corporation',
                  'Co-operative',
                  'Limited Liability Corporation',
                  'Non-profit Corporation',
                ].map(type => (
                  <MenuItem
                    disabled={type === 'Sole Proprietorship'}
                    key={type}
                    value={type}
                  >
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {formData.business_type &&
            formData.business_type !== 'Sole Proprietorship' ? (
              <FormControl
                disabled={disabled && !stepContainsErrorFields(activeStep)}
                component="fieldset"
                margin="normal"
              >
                <FormLabel component="legend">Messaging volume needs</FormLabel>
                <RadioGroup
                  disabled={disabled && !stepContainsErrorFields(activeStep)}
                  aria-label="Messaging volume needs"
                  name="volumeNeeds"
                  value={formData.volumeNeeds}
                  onChange={handleChange}
                >
                  <FormControlLabel
                    classes={{ root: classes.formControlLabelRoot }}
                    value="lowVolume"
                    control={<Radio />}
                    label={
                      'Low volume - ideal for smaller businesses ' +
                      'or those with limited messaging needs. ' +
                      'Limit of 2,000 text messages per day.'
                    }
                  />
                  <FormControlLabel
                    classes={{ root: classes.formControlLabelRoot }}
                    value="highVolume"
                    control={<Radio />}
                    label={
                      'High volume - suited for businesses with higher messaging volumes. ' +
                      'Registering involves an additional secondary vetting process. ' +
                      'Limit of 200,000 text messages per day.'
                    }
                  />
                </RadioGroup>
              </FormControl>
            ) : null}
            {/* This will be for later when we do an intermediate low volume: */}
            {/* {formData.volumeNeeds === 'highVolume' ? null : null} */}
          </>
        )
      case 1:
        return (
          <>
            <FormControl fullWidth margin="normal">
              <InputLabel>Company Type</InputLabel>
              <Select
                disabled={disabled && !stepContainsErrorFields(activeStep)}
                value={formData.company_type || ''}
                onChange={handleChange}
                name="company_type"
              >
                {['private', 'public', 'non-profit', 'government'].map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              error={errorFields.includes('business_name')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Business Name"
              name="business_name"
              helperText={
                formData.iso_country === 'CA'
                  ? ''
                  : 'PLEASE NOTE: This must be the exact legal business name as registered with the EIN, ' +
                    'which can be found on the CP 575 EIN Confirmation Letter. ' +
                    'An exact match between the legal business name and the EIN as ' +
                    'displayed on CP 575 is required to be successfully registered.'
              }
              value={formData.business_name || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('website_url')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Website URL"
              name="website_url"
              value={formData.website_url || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Business Industry</InputLabel>
              <Select
                disabled={disabled && !stepContainsErrorFields(activeStep)}
                value={formData.business_industry || ''}
                onChange={handleChange}
                name="business_industry"
              >
                {[
                  'AGRICULTURE',
                  'AUTOMOTIVE',
                  'BANKING',
                  'CONSTRUCTION',
                  'CONSUMER',
                  'EDUCATION',
                  'ELECTRONICS',
                  'ENERGY',
                  'ENGINEERING',
                  'FAST_MOVING_CONSUMER_GOODS',
                  'FINANCIAL',
                  'FINTECH',
                  'FOOD_AND_BEVERAGE',
                  'GOVERNMENT',
                  'HEALTHCARE',
                  'HOSPITALITY',
                  'INSURANCE',
                  'JEWELRY',
                  'LEGAL',
                  'MANUFACTURING',
                  'MEDIA',
                  'NOT_FOR_PROFIT',
                  'OIL_AND_GAS',
                  'ONLINE',
                  'PROFESSIONAL_SERVICES',
                  'RAW_MATERIALS',
                  'REAL_ESTATE',
                  'RELIGION',
                  'RETAIL',
                  'TECHNOLOGY',
                  'TELECOMMUNICATIONS',
                  'TRANSPORTATION',
                  'TRAVEL',
                ].map(industry => (
                  <MenuItem key={industry} value={industry}>
                    {capitalize(industry).replace(/_/g, ' ')}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              error={errorFields.includes('business_registration_number')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label={
                formData.iso_country === 'CA'
                  ? 'Canada Business Number (CBN)'
                  : 'Employer Identification Number (EIN)'
              }
              name="business_registration_number"
              // helperText={formData.iso_country === 'CA' ? '' : ''}
              value={formData.business_registration_number || ''}
              onChange={handleChange}
              fullWidth
              InputProps={{
                inputComponent: BusinessNumber,
                inputProps: {
                  format:
                    formData.iso_country === 'CA' ? '#########' : '##-#######',
                  mask: formData.iso_country === 'CA' ? '_' : '-',
                  onChange: handleChange,
                },
              }}
              margin="normal"
            />
          </>
        )
      case 2:
        return (
          <>
            <TextField
              error={errorFields.includes('street')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Street"
              name="street"
              value={formData.street || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('street_secondary')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Street (Secondary)"
              name="street_secondary"
              value={formData.street_secondary || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('city')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="City"
              name="city"
              value={formData.city || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('region')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label={
                formData.iso_country === 'CA'
                  ? 'Province/Territory'
                  : 'State/Territory'
              }
              name="region"
              helperText={
                formData.iso_country === 'CA'
                  ? '2-letter abbreviation. For example: ON'
                  : '2-letter abbreviation. For example: PA'
              }
              value={formData.region || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('postal_code')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label={formData.iso_country === 'CA' ? 'Postal Code' : 'ZIP Code'}
              name="postal_code"
              value={formData.postal_code || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          </>
        )
      case 3:
        return (
          <>
            <TextField
              error={errorFields.includes('first_name')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="First Name"
              name="first_name"
              value={formData.first_name || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('last_name')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Last Name"
              name="last_name"
              value={formData.last_name || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Job Position</InputLabel>
              <Select
                disabled={disabled && !stepContainsErrorFields(activeStep)}
                value={formData.job_position || ''}
                onChange={handleChange}
                name="job_position"
              >
                {[
                  'Director',
                  'VP',
                  'GM',
                  'General Counsel',
                  'CEO',
                  'CFO',
                  'Other',
                ].map(position => (
                  <MenuItem key={position} value={position}>
                    {position}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <TextField
              error={errorFields.includes('business_title')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Job Title"
              helperText="Here you can give your exact business title, or elaborate on the job position above"
              name="business_title"
              value={formData.business_title || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
            <TextField
              error={errorFields.includes('phone_number')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Phone Number"
              name="phone_number"
              value={formData.phone_number || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
              InputProps={{
                inputComponent: PhoneNumber,
                inputProps: { onChange: handleChange },
              }}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              error={errorFields.includes('email')}
              disabled={disabled && !stepContainsErrorFields(activeStep)}
              label="Email"
              name="email"
              value={formData.email || ''}
              onChange={handleChange}
              fullWidth
              margin="normal"
            />
          </>
        )
      // case 4:
      //   return (
      //     <div>
      //       {availableUseCases.map(useCase => (
      //         <div key={useCase.entityKey}>
      //           <FormControlLabel
      //             control={<Checkbox />}
      //             label={useCase.entityKey}
      //           />
      //           <Button onClick={() => handleEditUseCase(useCase)}>Edit</Button>
      //         </div>
      //       ))}
      //     </div>
      //   )
      case 4:
        return (
          <CampaignStep
            // TODO: change this
            entityType="useCaseDrafts"
            entityKey={
              formData.volumeNeeds === 'highVolume' ? 'MIXED' : 'LOW_VOLUME'
            }
          />
        )
      default:
        return 'Unknown step'
    }
  }

  const tooltipContent = (
    <>
      <h3>Why We Need This Information</h3>
      <div>
        To enhance our messaging services' reliability and compliance with
        industry standards, we require additional information about your
        business. This ensures our services remain secure, effective, and
        tailored to your needs while meeting regulatory requirements. Your
        cooperation in providing this information helps maintain service quality
        and security, benefiting both your interests and those of your
        customers. We are committed to protecting your information with strict
        privacy and security measures. Thank you for your cooperation in this
        essential process.
      </div>
    </>
  )

  if (
    directive === 'additionalHighVolumeUseCase' ||
    directive === 'upgradeToHighVolume'
  ) {
    return (
      <div className={classes.root}>
        <div
          style={{ marginLeft: 20, marginTop: 20 }}
          className={classes.titleText}
        >
          {directive === 'additionalHighVolumeUseCase'
            ? `ADD ${useCase} USE CASE`
            : directive === 'upgradeToHighVolume'
            ? `UPGRADE TO HIGH VOLUME ${useCase} USE CASE`
            : '10DLC COMPLIANCE APPLICATION'}
        </div>
        <div style={{ padding: '0 20px 20px' }}>
          <CampaignStep
            directive={directive}
            entityType="useCaseDrafts"
            entityKey={useCase}
          />
        </div>
      </div>
    )
  }

  return (
    <div className={classes.root}>
      <div
        style={{ marginLeft: 20, marginTop: 20 }}
        className={classes.titleText}
      >
        {activeStep !== 0 && (
          <Hidden mdUp>
            <Tooltip iconStyle={{ verticalAlign: 'bottom' }}>
              {tooltipContent}
            </Tooltip>
          </Hidden>
        )}
        10DLC COMPLIANCE APPLICATION{' '}
        {activeStep !== 0 && (
          <Hidden smDown>
            <Tooltip>{tooltipContent}</Tooltip>
          </Hidden>
        )}
      </div>
      {brandregistrationerrors
        ? getFormattedErrorMessage()
        : activeStep === 0 && (
            <div style={{ color: '#014c94', marginLeft: 20 }}>
              In order to send text messages to U.S. phone numbers, you must
              complete this form to comply with local messaging regulations.
              We've streamlined this process for you, and it should only take
              about 5 minutes to complete. Once submitted, the approval can take
              up to 2 weeks. You can check the status of your application
              anytime in your account, and we'll also notify you when there are
              updates.
            </div>
          )}
      <Stepper nonLinear activeStep={activeStep} orientation="vertical">
        {steps.map((label, index) => {
          const labelProps = {}
          if (stepsWithErrors.includes(index)) {
            labelProps.error = true // This will trigger the error styling for StepLabel
          }

          return (
            <Step key={label}>
              <StepButton onClick={() => setActiveStep(index)}>
                <StepLabel
                  {...labelProps}
                  className={
                    stepsWithErrors.includes(index) ? classes.errorStep : ''
                  }
                >
                  {label}
                </StepLabel>
              </StepButton>
              <StepContent>
                {getStepContent()}
                <div className={classes.actionsContainer}>
                  <div>
                    <Button
                      disabled={activeStep === 0}
                      onClick={handleBack}
                      className={classes.button}
                    >
                      Back
                    </Button>
                    <Button
                      disabled={disabled && activeStep === steps.length - 1}
                      variant="contained"
                      color="primary"
                      onClick={
                        activeStep === steps.length - 1
                          ? handleFinish
                          : handleNext
                      }
                      className={classes.button}
                    >
                      {activeStep === steps.length - 1 ? 'Finish' : 'Next'}
                    </Button>
                    {brandregistrationerrors ? (
                      <Button
                        disabled={!fieldsChanged}
                        onClick={handleResubmit}
                        className={classes.button}
                        variant="outlined"
                        color="secondary"
                      >
                        Resubmit
                      </Button>
                    ) : null}
                  </div>
                </div>
              </StepContent>
            </Step>
          )
        })}
      </Stepper>
      {activeStep === steps.length && (
        <Paper square elevation={0} className={classes.resetContainer}>
          <Typography>All steps completed - you're finished</Typography>
        </Paper>
      )}
    </div>
  )
}

export default connect(
  state => ({
    formData: state.a2p10dlc.formFields,
    useCaseDrafts: state.a2p10dlc.entities.useCaseDrafts,
    campaigns: state.a2p10dlc.entities.campaigns,
    createPhonePayload: state.view.dialogs?.A2P10DLC?.createPayload,
    a2p10dlc: state.data?.a2p10dlc,
    sms_double_opt_disclaimer:
      state.data?.['account/preference']?.preferences
        ?.sms_double_opt_disclaimer,
    idTokenPayload: state.auth?.session?.idToken?.payload,
  }),
  dispatch =>
    bindActionCreators(
      {
        create,
        update,
        updateA2p10dlc,
        updateFormField,
        updateEntity,
        updateMessageSamples,
        toggleDialog,
      },
      dispatch,
    ),
)(withStyles(styles)(A2P10DLC))
